// 单项目订单创建
export default {
    btn_queryByCard: "刷卡",
    btn_allEnter: "全部进场",
    table_title: "Item List",
    tl_index: "Number",
    tl_proj: "project",
    tl_kartName: "kartName",
    tl_space_proj: "Site/Project Name",
    tl_spec_player: "Model/Player",
    tl_price: "Price",
    tl_date: "Date/Time",
    tl_schedule: "Schedule",
    tl_num: "Number",
    tl_amount: "Subtotal",
    statistical_desc: "Total ticket order:",

    // 叫号列表
    tip_enter: "In the Ticket：",
    tip_group: "Group",
    tip_checked: "(checked)",

    // 新增项目
    dl_title: "Add item",
    dp_space: "Pick a space",
    dl_date: "Game Date",
    dp_date: "Pick a date",
    dl_projName: "Project Name",
    dp_projName: "Pick a project",
    dl_schedule: "Schedule",
    dp_schedule: "Schedule",
    op_code: "Field",
    dl_spec: "Model",
    dp_spec: "Pick a model",
    dl_originPrice: "Current Price",
    dl_price: "Original price",
    dl_quantity: "Inventory",
    dl_number: "Number",
    dp_number: "Please enter",
    dl_operator: "Operation",
    btn_addItem: "Add Order",

    em_number: "Number cannot be empty",
    em_quantityWarn: "Insufficient stock quantity",
    sm_addItem: "Added successfully",
    em_playerInput:
        "Please enter the corresponding number of contestants' information",
    em_nameExist: "Competitor name already exists",
    sm_allConsum: "All Consum",
    em_index: "The",
    em_consumTip: "ticket was written off successfully, and the rest failed",
    em_settingTip: "group operation succeeds, and the others fail",
    em_quantiy: "Quantity not sufficient",
    em_enterCardPw: "Enter your memberCard password"
};
